import '../styles/page-forvaltning.scss'

const modal = {

}

$(document).ready(function () {
});